import PropTypes from 'prop-types';

import ErrorState from '@zenbusiness/zui/ErrorState';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';

import * as Styled from './ErrorStateSection.style';

function ErrorStateSection({ title }) {
  return (
    <Stack spacing={1.5}>
      {title ? (
        <>
          <Styled.StyledPageHeader
            title={
              <Text color="primary" size="xl" weight="medium">
                {title}
              </Text>
            }
            paddingX={2}
          />
          <ErrorState />
        </>
      ) : (
        <ErrorState />
      )}
    </Stack>
  );
}

ErrorStateSection.propTypes = {
  title: PropTypes.string,
};

export default ErrorStateSection;
